import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { environment } from 'src/environments/environment';
import { JobDetails } from '../../models/job-details.models';
import { initialJobDetailsSlice } from './job-details.slice';

export const JobDetailsStore = signalStore(
    { providedIn: 'root' },
    withState(initialJobDetailsSlice),
    withMethods((store) => ({
        updateJobDetailsFromData: (data: JobDetails) => {
            patchState(store, { ...data });
        },
        getState: () => store
    })),
    environment.storeWithDevTools('locums-margin-calculator-job-details-store')
);
